import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UserService } from 'src/app/services/user.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notifications: any = {
    city: false,
    followed: false,
    useroficial: false,
    tickets: false
  };
  // Recordatorio por correo del evento, 24h antes. A diferencia del resto de
  // este formulario, este sí se guarda: va contra `users.allow_event_reminders`
  // por el PUT de usuario de siempre, no por `prefer_notifications`.
  eventReminders: boolean = true;
  originalEventReminders: boolean = true;
  oficial!: any;
  verified!: any;
  profileMe!: any;

  @Output() emitSave: EventEmitter<boolean> = new EventEmitter<boolean>();

  originalNotifications: any;
  hasChanges: boolean = false;

  constructor(
    private notificationsService: NotificationsService,
    private users: UserService,
    private auth: AuthenticationService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getData();
    this.loadEventReminders();
    this.notificationsService.getNotificationsUser().subscribe({
      next: (data) => {
        this.notifications = data;
        // Hacemos una copia profunda del objeto original después de recibir los datos
        this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
      },
      error: (err) => {
        console.error('Error al cargar notificaciones:', err);
        // Mantener los valores por defecto si hay error
        this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
      }
    })
  }

  getData() {
    this.profileMe = this.auth.getProfile();
    this.oficial = this.profileMe?.site;
    this.verified = this.profileMe?.sms;
  }

  /**
   * El valor se pide a /auth/me y no se coge del perfil en memoria: al entrar
   * directamente por la URL de notificaciones el perfil puede no estar cargado
   * todavía, y el toggle saldría en su valor por defecto.
   */
  loadEventReminders() {
    this.auth.getMyData().subscribe({
      next: (data) => {
        if (!data) {
          return;
        }
        this.profileMe = data;
        // Los usuarios de antes de esta preferencia no traen el campo, y la
        // columna nace en true: sin el ?? saldría desactivado sin serlo.
        this.eventReminders = data.allow_event_reminders ?? true;
        this.originalEventReminders = this.eventReminders;
      }
    });
  }

  saveNotifications() {
    this.emitSave.emit(this.notifications);

    if (this.eventReminders !== this.originalEventReminders && this.profileMe?.id) {
      this.users.putUser(this.profileMe.id, { allow_event_reminders: this.eventReminders }).subscribe({
        next: () => {
          this.originalEventReminders = this.eventReminders;
          // Para que el perfil en memoria no se quede con el valor viejo.
          this.auth.setProfile({ ...this.auth.getProfile(), allow_event_reminders: this.eventReminders });
        },
        error: () => {
          // Si falla se devuelve el toggle a su sitio, que si no la pantalla
          // dice una cosa y la base de datos otra.
          this.eventReminders = this.originalEventReminders;
          this.onToggleChange();
        }
      });
    }

    // Actualizamos el estado original
    this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
    this.hasChanges = false;
  }

  goBack() {
    this.location.back();
  }

  onToggleChange() {
    this.hasChanges = JSON.stringify(this.notifications) !== JSON.stringify(this.originalNotifications)
      || this.eventReminders !== this.originalEventReminders;
  }
}
